export const appKey = {
  development: '16440FE95FA2A86F',
  dev: '16440FE95FA2A86F',
  pre: '16440FE95FA2A86F',
  beta: '16440FE95FA2A86F',
  release: '90EA0E0834963405',
};
